import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { useTranslation } from 'react-i18next';

const CustomTable = ({
  data,
  isLoading,
  columns = [],
  tableStyle = { minWidth: '50rem' },
  paginator = false,
  emptyMessage = 'NoResultsFound.',
  rootyStyles = 'overflow-auto border border-gray-200 rounded border-b-0 custom-table',
  rowClassName = '',
  onRowClick = () => { },
  showExpander = false,
  expanderStyle = { width: '3rem' },
  ...rest
}) => {
  const { t, i18n } = useTranslation();

  return (
    <DataTable
      key={i18n.language}
      dir={i18n.dir()}
      onRowClick={onRowClick}
      value={isLoading ? Array(7).fill({}) : data}
      tableStyle={tableStyle}
      paginator={paginator}
      emptyMessage={t(emptyMessage)}
      rowClassName={rowClassName}
      pt={{
        root: { className: rootyStyles },
        loadingIcon: { className: 'text-primary' },
        loadingOverlay: { className: 'bg-[rgba(0,0,0,0.2)]' },
        wrapper: { className: 'scrollbar' }
      }}
      {...rest}
    >
      {showExpander && rest.rowExpansionTemplate && (
        <Column
          expander
          style={expanderStyle}
          pt={{
            headerCell: {
              className: `!px-[0.35rem] !py-[0.6rem] bg-gray-300`
            },
            bodyCell: {
              className: `!px-[0.35rem] !py-[0.6rem] border-b !border-b-gray-200`
            }
          }}
        />
      )}
      {columns?.map((col, index) => (
        <Column
          key={index}
          field={col?.field}
          header={col?.header}
          body={isLoading ? () => <Skeleton width='100%' height='1.5rem' /> : col?.body}
          style={{ ...col.style }}
          pt={{
            headerCell: {
              className: `!px-[0.35rem] !py-[0.6rem] bg-gray-300 text-start ${col.headerCellClass || ''}`,
              ...col.pt?.headerCell
            },
            headerTitle: {
              className: `text-14-dark !font-[600] whitespace-nowrap text-start ${col.headerTitleClass || ''}`
            },
            bodyCell: {
              className: `!px-[0.35rem] !py-[0.6rem] text-12-gray leading-[1.25rem] border-b !border-b-gray-200 whitespace-nowrap text-start ${col.bodyCellClass || ''} `,
              ...col.pt?.bodyCell
            },
            ...col.pt
          }}
          {...col.extraProps}
        />
      ))}
    </DataTable>
  );
};

export default CustomTable;
